<template>
<div class="chapter">
<div class="inner_page">
<div class="Chapter_Page">
<h2 class="toc-head">Contents</h2>
<p class="toc"><a href="#/05_Chapter1" id="s1"><span class="space">1.</span>Q &amp; A</a></p>
<p class="toc"><span href="#/06_Chapter2" id="s2" title="Link target outside of Sample"><span class="space">2.</span>DOGS &amp; CATS</span></p>
<p class="toc"><span href="#/07_Chapter3" id="s3" title="Link target outside of Sample"><span class="space">3.</span>YUM YUKS!</span></p>
<p class="toc"><span href="#/08_Chapter4" id="s4" title="Link target outside of Sample"><span class="space">4.</span>Arrr!</span></p>
<p class="toc"><span href="#/09_Chapter5" id="s5" title="Link target outside of Sample"><span class="space">5.</span>FAIRY FUNNY!</span></p>
<p class="toc"><span href="#/10_Chapter6" id="s6" title="Link target outside of Sample"><span class="space">6.</span>KNOCK-KNOCK!</span></p>
<p class="toc"><span href="#/11_Chapter7" id="s7" title="Link target outside of Sample"><span class="space">7.</span>ELEPHANTS</span></p>
<p class="toc"><span href="#/12_Chapter8" id="s8" title="Link target outside of Sample"><span class="space">8.</span>HUMDINGERS</span></p>
<p class="toc"><span href="#/13_Chapter9" id="s9" title="Link target outside of Sample"><span class="space">9.</span>SPACE CASE</span></p>
<p class="toc1"><span href="#/14_Chapter10" id="s10" title="Link target outside of Sample"><span class="space">10.</span>ONE-LINERS</span></p>
<p class="toc1"><span href="#/15_Chapter11" id="s11" title="Link target outside of Sample"><span class="space">11.</span>ANIMAL ANTICS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?3abc768e